<p-dropdown
  placeholder="Selecione..."
  [options]="localeOptions"
  [(ngModel)]="locationSelected"
  (onChange)="select($event)"
   name="movementLocation" appendTo="body">
</p-dropdown>
